<template>
  <div v-if="isLogin" class="reqWrap">
    <div class="u-containar-md">
      <Alert v-if="alertMessage.show" :text="alertMessage.text" />

      <div v-if="isLogin" class="reqForm">
        <section>
          <HeadingLv3 text="申込み先イベント" />
          <PreviewPairData
            v-for="(item, key) in data.event"
            :key="key"
            :label="item.label"
            :content="item.content"
          />
        </section>

        <section>
          <HeadingLv3 text="登録情報" />

          <div class="reqBox">
            <p>
              すでに登録してある会員情報を変更したい場合は、マイページから変更してください。
            </p>
            <TextLink link="/mypage/user/profile" text="マイページはこちら" />
          </div>

          <PreviewPairData
            :label="data.user.name.label"
            :content="data.user.name.content"
          />
          <PreviewPairData
            :label="data.user.name_kana.label"
            :content="data.user.name_kana.content"
          />
          <PreviewPairData
            :label="data.user.gender.label"
            :content="data.user.gender.content"
          />
          <PreviewPairData
            :label="data.user.birthday.label"
            :content="data.user.birthday.content"
          />
          <PreviewPairData
            :label="data.user.email.label"
            :content="data.user.email.content"
          />

          <PreviewPairData
            v-if="data.user.address"
            :label="data.user.address.label"
            :content="data.user.address.content"
          />

          <FormGroup v-if="!data.user.address" label="住所" req>
            <FormInputField
              name="zip"
              label="郵便番号"
              patternLabel="半角英数"
              placeholder="郵便番号7桁を入力（ハイフン無し）"
              description="＊郵便番号を入力すると住所が自動検索されます。"
              :value="notEnterdData.zip"
              :error="validations.zip.isError"
              :error-message="validations.zip.errorMessage"
              @change-message="inputZip('zip', $event)"
              size="lg"
              formGroupReq
            />
            <FormSelectField
              id="prefecture"
              name="prefecture"
              label="都道府県"
              :value="notEnterdData.prefecture"
              :error="validations.prefecture.isError"
              :error-message="validations.prefecture.errorMessage"
              :items="prefectures"
              @change-message="changeMessage('prefecture', $event)"
              formGroupReq
            />
            <FormInputField
              id="profile07"
              label="市区町村"
              name="municipalities"
              patternLabel="全角"
              placeholder="例：千代田区"
              :value="notEnterdData.city"
              :error="validations.city.isError"
              :error-message="validations.city.errorMessage"
              @change-message="changeMessage('city', $event)"
              formGroupReq
            />
            <FormInputField
              id="profile08"
              name="municipalitiesNameNumber"
              label="町名番地、建物等"
              patternLabel="全角"
              placeholder="例：神田佐久間町1-33-3 〇〇マンション101号室"
              :value="notEnterdData.town"
              :error="validations.town.isError"
              :error-message="validations.town.errorMessage"
              @change-message="changeMessage('town', $event)"
              formGroupReq
            />
          </FormGroup>

          <PreviewPairData
            v-if="data.user.tel.content"
            :label="data.user.tel.label"
            :content="data.user.tel.content"
          />

          <FormInputField
            v-if="!data.user.tel.content"
            id="profile10"
            label="電話番号"
            patternLabel="半角英数"
            placeholder="000-000-0000"
            name="telPhoneNumber"
            :value="notEnterdData.tel"
            :error="validations.tel.isError"
            :error-message="validations.tel.errorMessage"
            @change-message="changeMessage('tel', $event)"
            req
          />

          <PreviewPairData
            v-if="data.user.address_vacation"
            :label="data.user.address_vacation.label"
            :content="data.user.address_vacation.content"
          />

          <FormFieldset
            v-if="!data.user.address_vacation"
            label="休暇中住所"
            req
          >
            <CheckboxButtons
              name="diff_address"
              :items="[
                {
                  label: '上記の住所と同じ',
                  value: '1',
                  id: 'diff_address',
                  checked: notEnterdData.vacation_flg,
                  error: false
                }
              ]"
              style="white-space: nowrap"
              @change-checkbox="changeVacationAddressState"
            />
          </FormFieldset>

          <FormGroup v-if="!data.user.address_vacation">
            <FormInputField
              id="profile05"
              label="郵便番号"
              patternLabel="全角"
              placeholder="郵便番号7桁を入力（ハイフン無し）"
              description="＊郵便番号を入力すると住所が自動検索されます。"
              :value="notEnterdData.zip_vacation"
              :error="validations.zip_vacation.isError"
              :error-message="validations.zip_vacation.errorMessage"
              :disabled="notEnterdData.vacation_flg"
              @change-message="inputZip('zip_vacation', $event)"
              size="lg"
              formGroupReq
            />
            <FormSelectField
              id="prefecture_vacation"
              name="prefecture_vacation"
              label="都道府県"
              :value="notEnterdData.prefecture_vacation"
              :error="validations.prefecture_vacation.isError"
              :error-message="validations.prefecture_vacation.errorMessage"
              :items="prefectures_vacation"
              :disabled="notEnterdData.vacation_flg"
              @change-message="changeMessage('prefecture_vacation', $event)"
              formGroupReq
            />
            <FormInputField
              id="profile07"
              label="市区町村"
              patternLabel="全角"
              placeholder="例：千代田区"
              :value="notEnterdData.city_vacation"
              :error="validations.city_vacation.isError"
              :error-message="validations.city_vacation.errorMessage"
              :disabled="notEnterdData.vacation_flg"
              @change-message="changeMessage('city_vacation', $event)"
              formGroupReq
            />
            <FormInputField
              id="profile08"
              name="municipalitiesNameNumber"
              label="町名番地、建物等"
              patternLabel="全角"
              placeholder="例：神田佐久間町1-33-3 〇〇マンション101号室"
              :value="notEnterdData.town_vacation"
              :error="validations.town_vacation.isError"
              :error-message="validations.town_vacation.errorMessage"
              :disabled="notEnterdData.vacation_flg"
              @change-message="changeMessage('town_vacation', $event)"
              formGroupReq
            />
          </FormGroup>

          <PreviewPairData
            :label="data.user.school.label"
            :content="data.user.school.content"
          />
          <PreviewPairData
            v-if="data.user.graduate_year"
            :label="data.user.graduate_year.label"
            :content="data.user.graduate_year.content"
          />
          <PreviewPairData
            v-if="data.user.work_place"
            :label="data.user.work_place.label"
            :content="data.user.work_place.content"
          />
          <PreviewPairData
            v-if="data.user.licensing_year"
            :label="data.user.licensing_year.label"
            :content="data.user.licensing_year.content"
          />
        </section>
      </div>
    </div>
    <GoalButtons type="contents">
      <Button
        v-if="showPrevBtn"
        label="戻る"
        :handleClick="() => $router.go(-1)"
      />
      <Button
        label="送信内容の確認"
        :handleClick="clickConfirmBtn"
        :disabled="isDisabledNextBtn"
        primary
      />
    </GoalButtons>
  </div>
  <template v-else>
    <div class="u-containar-md">
      <div class="loginWrap">
        <Login
          defaultAlertMessage="※イベント申し込みにはログインが必要です。"
          hideHeading
          hideRegisterArea
          :useOutdatedStyle="false"
          :redirect="$route.path"
        />
      </div>
    </div>
    <ToRegisterEvent />
  </template>
</template>

<script lang="ts">
import axios from 'axios'
import {
  defineComponent,
  reactive,
  SetupContext,
  computed,
  onMounted,
  PropType
} from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { applyValidation } from '@/utils/validation'
import Login from '@/views/Login.vue'
import Button from '@/components/elements/Button.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import FormGroup from '@/components/block/FormGroup.vue'
import FormFieldset from '@/components/block/FormFieldset.vue'
import FormInputField from '@/components/block/FormInputField.vue'
import FormSelectField from '@/components/block/FormSelectField.vue'
import CheckboxButtons from '@/components/block/FormCheckboxButtons.vue'
import PreviewPairData from '@/components/block/PreviewPairData.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import Alert from '@/components/elements/Alert.vue'
import ToRegisterEvent from '@/components/block/ToRegisterEvent.vue'
import TextLink from '@/components/elements/TextLink.vue'
import {
  EventReserveFormState,
  EventReserveFormData,
  EventReserveFormNotEnterdData
} from '@/types/EventsReserve' // eslint-disable-line

export default defineComponent({
  name: 'EventReserveInput',

  components: {
    Login,
    Button,
    Alert,
    HeadingLv3,
    FormGroup,
    FormFieldset,
    FormInputField,
    FormSelectField,
    PreviewPairData,
    GoalButtons,
    CheckboxButtons,
    TextLink,
    ToRegisterEvent
  },

  props: {
    state: {
      type: Object as PropType<EventReserveFormState>,
      required: true
    },
    data: {
      type: Object as PropType<EventReserveFormData>,
      default: () => ({})
    },
    notEnterdData: {
      type: Object as PropType<EventReserveFormNotEnterdData>,
      default: () => ({})
    },
    err: {
      type: Object,
      default: () => ({})
    }
  },

  setup(props, context: SetupContext) {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    // 申し込みフローの更新
    context.emit('update-flow', 1)

    // 入力ページから入ってきているステータスを設定
    context.emit('update-landing-state', true)

    // ------------------------------------------------------
    // バリデーション設定
    // ------------------------------------------------------
    interface ValidationsObject {
      [key: string]: {
        rules: string[]
        isError: boolean
        errorMessage: string
      }
    }

    const validations: ValidationsObject = reactive({
      zip: {
        rules: ['required', 'zip'],
        isError: false,
        errorMessage: ''
      },
      prefecture: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      city: {
        rules: ['required', 'max:255'],
        isError: false,
        errorMessage: ''
      },
      town: {
        rules: ['required', 'max:255'],
        isError: false,
        errorMessage: ''
      },
      tel: {
        rules: ['required', 'max:500', 'hankakueisu'],
        isError: false,
        errorMessage: ''
      },
      zip_vacation: {
        rules: ['required', 'zip'],
        isError: false,
        errorMessage: ''
      },
      prefecture_vacation: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      city_vacation: {
        rules: ['required', 'max:255'],
        isError: false,
        errorMessage: ''
      },
      town_vacation: {
        rules: ['required', 'max:255'],
        isError: false,
        errorMessage: ''
      }
    })

    // 内容確認ボタン
    const clickConfirmBtn = () => {
      router.push({
        path: `/events/reserve/confirm/${route.params.id}`
      })
    }

    const changeMessage = (name: string, value: string) => {
      context.emit('update-data', name, value)

      const result = applyValidation(validations[name].rules, value)

      validations[name].isError = result.isError
      validations[name].errorMessage = result.message
    }

    const changeVacationAddressState = (ev: Record<string, boolean>) => {
      context.emit('update-data', 'vacation_flg', ev.checked)

      const arr = [
        'zip_vacation',
        'prefecture_vacation',
        'city_vacation',
        'town_vacation'
      ]

      for (let i = 0; i < arr.length; i++) {
        if (ev.checked) {
          validations[arr[i]].isError = false
        } else {
          const value = props.notEnterdData[arr[i]]
          if (typeof value === 'string') {
            const result = applyValidation(validations[arr[i]].rules, value)
            validations[arr[i]].isError = result.isError
            validations[arr[i]].errorMessage = result.message
          }
        }
      }
    }

    // 確認ボタンの活性・非活性制御
    const isDisabledNextBtn = computed(() => {
      if (
        (!props.data.user.address && props.notEnterdData.zip === '') ||
        (!props.data.user.address && props.notEnterdData.prefecture === '') ||
        (!props.data.user.address && props.notEnterdData.city === '') ||
        (!props.data.user.address && props.notEnterdData.town === '') ||
        (props.data.user.tel &&
          !props.data.user.tel.content &&
          props.notEnterdData.tel === '')
      ) {
        return true
      }

      if (
        !props.data.user.address_vacation &&
        !props.notEnterdData.vacation_flg
      ) {
        if (
          props.notEnterdData.zip_vacation === '' ||
          props.notEnterdData.prefecture_vacation === '' ||
          props.notEnterdData.city_vacation === '' ||
          props.notEnterdData.town_vacation === ''
        ) {
          return true
        }
      }

      const arr: Array<string> = Object.keys(validations)

      for (let i = 0; i < arr.length; i++) {
        if (validations[arr[i]].isError) return true
      }

      return false
    })

    interface SelectObject {
      label: string
      value: string
      selected: boolean
    }
    const selectDefault = {
      label: '選択してください',
      value: '',
      selected: false
    }
    const prefectures: Array<SelectObject> = reactive([selectDefault])
    const prefectures_vacation: Array<SelectObject> = reactive([selectDefault])
    const selectedPref = props.notEnterdData.prefecture
      ? props.notEnterdData.prefecture
      : 0
    const selectedPrefVacation = props.notEnterdData.prefecture_vacation
      ? props.notEnterdData.prefecture_vacation
      : 0

    store.state.master.prefectures.forEach((el: any) => {
      if (el.opt_id === '0') return

      const item: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedPref === el.opt_id ? true : false
      }
      const item2: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedPrefVacation === el.opt_id ? true : false
      }
      prefectures.push(item)
      prefectures_vacation.push(item2)
    })

    // 郵便番号から住所取得 @TODO 共通化できそうならする
    const getAddressFromZipCode = (name: string, value: string) => {
      const zip1 = value.substr(0, 3)
      const zip2 = value.substr(3, 4)

      axios
        .get(
          `https://madefor.github.io/postal-code-api/api/v1/${zip1}/${zip2}.json`
        )
        .then((res) => {
          let selectedPref = 0

          for (let i = 0; i < prefectures.length; i++) {
            if (
              Number(res.data.data[0].prefcode) === Number(prefectures[i].value)
            ) {
              selectedPref = i
            }
          }

          if (name === 'zip') {
            prefectures[selectedPref].selected = true
            changeMessage('prefecture', prefectures[selectedPref].value)
            changeMessage('city', res.data.data[0].ja.address1)
            changeMessage('town', res.data.data[0].ja.address2)
          }
          if (name === 'zip_vacation') {
            prefectures_vacation[selectedPref].selected = true
            changeMessage(
              'prefecture_vacation',
              prefectures_vacation[selectedPref].value
            )
            changeMessage('city_vacation', res.data.data[0].ja.address1)
            changeMessage('town_vacation', res.data.data[0].ja.address2)
          }
        })
    }

    const inputZip = (name: string, value: string) => {
      changeMessage(name, value)

      if (/^[0-9]{7}$/.test(value)) {
        getAddressFromZipCode(name, value)
      }
    }

    const showPrevBtn = window.history.state.back ? true : false

    const alertMessage: any = reactive({
      text: '',
      show: false
    })

    // サーバーサイドのバリデーションエラーで戻って来た時
    onMounted(() => {
      if (Object.keys(props.err).length > 0) {
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            behavior: 'auto'
          })
        }, 100)

        if (props.err.indexOf('申し込み済') > -1) {
          alertMessage.text = props.err
          alertMessage.show = true
          return
        }

        Object.keys(props.err).forEach((key: string) => {
          validations[key].isError = true
          validations[key].errorMessage = props.err[key][0]
        })
      }
    })

    return {
      validations,
      changeMessage,
      changeVacationAddressState,
      prefectures,
      prefectures_vacation,
      inputZip,
      isDisabledNextBtn,
      clickConfirmBtn,
      showPrevBtn,
      alertMessage,
      isLogin: store.state.isLogin
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.loginWrap {
  margin-left: -16px;
  margin-right: -16px;
  overflow: hidden;

  @include mixins.media() {
    margin-left: -20px;
    margin-right: -20px;
  }
}

.reqWrap {
  margin-bottom: -30px;
}

.reqForm {
  overflow: hidden;
  margin-bottom: -25px;

  section {
    margin-bottom: 40px;

    @include mixins.media() {
      margin-bottom: 60px;
    }
  }

  ::v-deep .headingLv3 {
    margin-bottom: 20px;
  }

  ::v-deep .inputDataPreview + .formField {
    margin-top: 28px;
  }

  ::v-deep .formGroup + .inputDataPreview,
  ::v-deep .formField + .inputDataPreview {
    margin-top: 28px;
    border-top: 1px solid #e4e4e4;
    padding-top: 20px;
  }
}

.reqBox {
  border: 1px solid var.$color-main;
  line-height: 1.7;
  padding: 16px;
  margin-bottom: 25px;
}
</style>
